import { useIndexerQuery } from "@/shared/indexer/useIndexerQuery"
import { Listing } from "../types"
import { MARKETPLACE_CHAIN_ID } from "../marketplace-chain-id"

export function useMarketplaceListings() {
  const query = useIndexerQuery<Listing[]>({
    commandName: "marketplaceListings",
    variables: {
      chainId: MARKETPLACE_CHAIN_ID,
      status: "ACTIVE",
    },
    enabled: Boolean(MARKETPLACE_CHAIN_ID),
    select: (data: { data: { MarketplaceListing: Listing[] } }) =>
      data?.data?.MarketplaceListing || [],
  })

  return {
    listings: query.data || [],
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  }
}
